import { render, staticRenderFns } from "./AbaEditarVencedores.vue?vue&type=template&id=42618a97&scoped=true"
import script from "./AbaEditarVencedores.vue?vue&type=script&lang=ts"
export * from "./AbaEditarVencedores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42618a97",
  null
  
)

export default component.exports